import { defineMessages } from 'react-intl'

export default defineMessages({
  booleanOperatorErrorLeft: {
    id: 'SpaceAppBuilderFeaturesPage.operation.boolean.rule.errorLeft',
    defaultMessage: 'Please select a left comparator.'
  },
  booleanOperatorErrorRight: {
    id: 'SpaceAppBuilderFeaturesPage.operation.boolean.rule.errorRight',
    defaultMessage: 'Please select a right comparator.'
  },
  confirmDeleteCondition: {
    id: 'SpaceAppBuilderFeaturesPage.operation.boolean.rule.deleteRule',
    defaultMessage: 'Are you sure you want to delete this boolean rule condition?'
  },
  addRule: {
    id: 'SpaceAppBuilderFeaturesPage.operation.boolean.rule.addRule',
    defaultMessage: 'Add an OR rule'
  },
  addCondition: {
    id: 'SpaceAppBuilderFeaturesPage.operation.boolean.rule.addCondition',
    defaultMessage: 'Add an AND condition'
  },
  ruleDefinition: {
    id: 'SpaceAppBuilderFeaturesPage.operation.boolean.rule.definition',
    defaultMessage: 'BOOLEAN DEFINITION'
  },
  ruleTitle: {
    id: 'SpaceAppBuilderFeaturesPage.operation.boolean.rule.title',
    defaultMessage: 'Rule {index}'
  },
  if: {
    id: 'SpaceAppBuilderFeaturesPage.operation.boolean.rule.if',
    defaultMessage: 'If'
  },
  and: {
    id: 'SpaceAppBuilderFeaturesPage.operation.boolean.rule.and',
    defaultMessage: 'and'
  },
  boolean: {
    id: 'SpaceAppBuilderFeaturesPage.operation.boolean.label',
    defaultMessage: 'Boolean'
  },
  filter: {
    id: 'SpaceAppBuilderFeaturesPage.operation.dataTransform.filter',
    defaultMessage: 'Filter'
  },
  pick: {
    id: 'SpaceAppBuilderFeaturesPage.operation.dataTransform.pick',
    defaultMessage: 'Pick'
  },
  find: {
    id: 'SpaceAppBuilderFeaturesPage.operation.dataTransform.find',
    defaultMessage: 'Find'
  },
  group: {
    id: 'SpaceAppBuilderFeaturesPage.operation.dataTransform.group',
    defaultMessage: 'Group'
  },
  sort: {
    id: 'SpaceAppBuilderFeaturesPage.operation.dataTransform.sort',
    defaultMessage: 'Sort'
  },
  dataTransform: {
    id: 'SpaceAppBuilderFeaturesPage.operation.dataTransform.label',
    defaultMessage: 'Data Transform Utility'
  },
  dataTransformTooltipData: {
    id: 'SpaceAppBuilderFeaturesPage.operation.dataTransform.dataTransformTooltipData',
    defaultMessage: 'Data'
  },
  dataTransformTooltipInput: {
    id: 'SpaceAppBuilderFeaturesPage.operation.dataTransform.dataTransformTooltipInput',
    defaultMessage: 'Input'
  },
  dataTransformTooltipOutput: {
    id: 'SpaceAppBuilderFeaturesPage.operation.dataTransform.dataTransformTooltipOutput',
    defaultMessage: 'Output'
  },
  selectAction: {
    id: 'SpaceAppBuilderFeaturesPage.operation.dataTransform.selectAction',
    defaultMessage: 'Select Action'
  },
  dataTransformAddAction: {
    id: 'SpaceAppBuilderFeaturesPage.operation.dataTransform.addAction',
    defaultMessage: 'Add Action'
  },
  dataTransformDescription: {
    id: 'SpaceAppBuilderFeaturesPage.operation.dataTransform.description',
    defaultMessage:
      'Apply modifications to data such as filtering or re-ordering lists, perform list item counts ...etc'
  },
  dataTransformFilterDescription: {
    id: 'SpaceAppBuilderFeaturesPage.operation.dataTransform.filter.description',
    defaultMessage:
      'Filter an array using a set of conditions. The result will be an array of items that meet the search criteria.'
  },
  dataTransformPickDescription: {
    id: 'SpaceAppBuilderFeaturesPage.operation.dataTransform.pick.description',
    defaultMessage: 'The result will be an array of objects based on the picked object properties.'
  },
  dataTransformFindDescription: {
    id: 'SpaceAppBuilderFeaturesPage.operation.dataTransform.find.description',
    defaultMessage:
      'Find a record in an array using a set of conditions. The result will be the first record that meets the search criteria.'
  },
  dataTransformGroupDescription: {
    id: 'SpaceAppBuilderFeaturesPage.operation.dataTransform.group.description',
    defaultMessage:
      'Group an array by a specified property key. The result will be an object containing the specified property key values'
  },
  dataTransformSortDescription: {
    id: 'SpaceAppBuilderFeaturesPage.operation.dataTransform.sort.description',
    defaultMessage: 'Sort an array by a specified property key. The sort order can also be specified.'
  },
  dataTransformInputLabel: {
    id: 'SpaceAppBuilderFeaturesPage.operation.dataTransform.dataTransformInputLabel',
    defaultMessage: 'Select input data to be transformed'
  },
  dataTransformInputPlaceholder: {
    id: 'SpaceAppBuilderFeaturesPage.operation.dataTransform.dataTransformInputPlaceholder',
    defaultMessage: 'Select input variable'
  },
  dataTransformPlaceholder: {
    id: 'SpaceAppBuilderFeaturesPage.operation.dataTransform.dataTransformPlaceholder',
    defaultMessage: 'Select transform action'
  },
  codeEditorValuePlaceholder: {
    id: 'SpaceAppBuilderFeaturesPage.operation.codeEditor.parameter.ValuePlaceholder',
    defaultMessage: 'Select variable from previous step'
  },
  codeEditorKeyPlaceholder: {
    id: 'SpaceAppBuilderFeaturesPage.operation.codeEditor.parameter.KeyPlaceholder',
    defaultMessage: 'Enter parameter name'
  },
  addInputVariable: {
    id: 'SpaceAppBuilderFeaturesPage.operation.codeEditor.addInputVariable',
    defaultMessage: 'Add input variable'
  },
  adaptiveCard: {
    id: 'SpaceAppBuilderFeaturesPage.operation.adaptiveCard',
    defaultMessage: 'Adaptive Card'
  },
  customCode: {
    id: 'SpaceAppBuilderFeaturesPage.operation.customCode',
    defaultMessage: 'Custom Code'
  },
  codeEditorDescription: {
    id: 'SpaceAppBuilderFeaturesPage.operation.codeEditor.description',
    defaultMessage: 'What data would you like to use as input to your function?'
  },
  codeEditorNoVariablesWarning: {
    id: 'SpaceAppBuilderFeaturesPage.operation.codeEditor.codeEditorNoVariablesWarning',
    defaultMessage: 'To input data to your javascript function add a step before that outputs variables.'
  },
  codeEditorTooltip: {
    id: 'SpaceAppBuilderFeaturesPage.operation.codeEditor.tooltip',
    defaultMessage:
      "To return data from the function script use the done callback function paramater eg - done(output). \n\n \n\nBelow is a list of libraries that can be used in your script - `const moment = require('moment')`. \n\n- [moment](https://momentjs.com/docs/#/parsing/string-format/) \n\n- [lodash](https://lodash.com/docs/4.17.15)"
  },
  scriptParameterNameRequired: {
    id: 'SpaceAppBuilderFeaturesPage.operation.codeEditor.scriptParameterNameRequired',
    defaultMessage: 'Please enter an input parameter name'
  },
  scriptParameterValueRequired: {
    id: 'SpaceAppBuilderFeaturesPage.operation.codeEditor.scriptParameterValueRequired',
    defaultMessage: 'Please select an input parameter value'
  },
  responseValueRequired: {
    id: 'SpaceAppBuilderFeaturesPage.operation.codeEditor.responseValueRequired',
    defaultMessage: 'Please enter a value'
  },
  output: {
    id: 'SpaceAppBuilderFeaturesPage.operation.codeEditor.output',
    defaultMessage: 'To generate output variables for this step'
  },
  javascriptFunctionDeclaration: {
    id: 'SpaceAppBuilderFeaturesPage.operation.codeEditor.javascriptFunctionDeclaration',
    defaultMessage: 'function(input, packages, done)'
  },
  javascriptFunctionDeclarationWithNoInput: {
    id: 'SpaceAppBuilderFeaturesPage.operation.codeEditor.javascriptFunctionDeclarationWithNoInput',
    defaultMessage: 'function(packages, done)'
  },
  customScript: {
    id: 'SpaceAppBuilderFeaturesPage.operation.codeEditor.customScript',
    defaultMessage: 'Javascript function'
  },
  variableName: {
    id: 'SpaceAppBuilderFeaturesPage.operation.codeEditor.variableName',
    defaultMessage: 'variableName'
  },
  inputDescription: {
    id: 'SpaceAppBuilderFeaturesPage.operation.codeEditor.inputDescription',
    defaultMessage: 'Input variables above can be accesed via the input function parameter eg (input.{variableName})'
  },
  booleanDescription: {
    id: 'SpaceAppBuilderFeaturesPage.operation.boolean.description',
    defaultMessage: 'Set rules about conditions'
  },
  trueFalse: {
    id: 'SpaceAppBuilderFeaturesPage.operation.boolean.subLabel',
    defaultMessage: 'True/False'
  },
  rightComparator: {
    id: 'SpaceAppBuilderFeaturesPage.operation.boolean.rightComparator',
    defaultMessage: 'Right Comparator'
  },
  leftComparator: {
    id: 'SpaceAppBuilderFeaturesPage.operation.boolean.leftComparator',
    defaultMessage: 'Left Comparator'
  },
  equalsOperator: {
    id: 'SpaceAppBuilderFeaturesPage.operation.boolean.equalsOperator',
    defaultMessage: '='
  },
  notEqualOperator: {
    id: 'SpaceAppBuilderFeaturesPage.operation.boolean.notEqualOperator',
    defaultMessage: '≠'
  },
  containsOperator: {
    id: 'SpaceAppBuilderFeaturesPage.operation.boolean.containsOperator',
    defaultMessage: 'contains'
  },
  startsWithOperator: {
    id: 'SpaceAppBuilderFeaturesPage.operation.boolean.startsWithOperator',
    defaultMessage: 'starts with'
  },
  endsWithOperator: {
    id: 'SpaceAppBuilderFeaturesPage.operation.boolean.endsWithOperator',
    defaultMessage: 'ends with'
  },
  hasValueOperator: {
    id: 'SpaceAppBuilderFeaturesPage.operation.boolean.hasValueOperator',
    defaultMessage: 'has value'
  },
  greaterThanOperator: {
    id: 'SpaceAppBuilderFeaturesPage.operation.boolean.greaterThanOperator',
    defaultMessage: '>'
  },
  greaterThanOrEqualOperator: {
    id: 'SpaceAppBuilderFeaturesPage.operation.boolean.greaterThanOrEqualOperator',
    defaultMessage: '≥'
  },
  lessThanOperator: {
    id: 'SpaceAppBuilderFeaturesPage.operation.boolean.lessThanOperator',
    defaultMessage: '<'
  },
  lessThanOrEqualOperator: {
    id: 'SpaceAppBuilderFeaturesPage.operation.boolean.lessThanOrEqualOperator',
    defaultMessage: '≤'
  },
  logMessage: {
    id: 'SpaceAppBuilderFeaturesPage.operations.output',
    defaultMessage: 'Log Message'
  },
  userQuery: {
    id: 'SpaceAppBuilderFeaturesPage.operations.userQuery',
    defaultMessage: 'User Query'
  },
  userLookup: {
    id: 'SpaceAppBuilderFeaturesPage.operations.userLookup',
    defaultMessage: 'User Lookup'
  },
  userLookupDescription: {
    id: 'SpaceAppBuilderFeaturesPage.operation.userLookup.description',
    defaultMessage:
      'Search for users in your organization. Users can be queried by name, email, or user id. Organizational chart data can be retrieved by enabling their respective options.'
  },
  runFeature: {
    id: 'SpaceAppBuilderFeaturesPage.operations.runFeature',
    defaultMessage: 'Run Feature'
  },
  runCapability: {
    id: 'SpaceAppBuilderFeaturesPage.operations.runCapability',
    defaultMessage: 'Run Capability'
  },
  runType: {
    id: 'SpaceAppBuilderFeaturesPage.operations.executionType',
    defaultMessage: 'Run Type'
  },
  selectRunType: {
    id: 'SpaceAppBuilderFeaturesPage.operations.selectExecutionType',
    defaultMessage: 'Select execution type'
  },
  fireAndForget: {
    id: 'SpaceAppBuilderFeaturesPage.operations.fireAndForget',
    defaultMessage: 'Run and continue'
  },
  fireAndForgetDescription: {
    id: 'SpaceAppBuilderFeaturesPage.operations.fireAndForgetDescription',
    defaultMessage: 'Runs a feature asynchronously meaning the calling feature does not wait for a response'
  },
  fireAndWait: {
    id: 'SpaceAppBuilderFeaturesPage.operations.fireAndWait',
    defaultMessage: 'Run and wait'
  },
  fireAndWaitDescription: {
    id: 'SpaceAppBuilderFeaturesPage.operations.fireAndWaitDescription',
    defaultMessage: 'Runs a feature synchronously meaning the calling feature does wait for a response'
  },
  runFeatureTriggerDescription: {
    id: 'SpaceAppBuilderFeaturesPage.runFeatureTriggerDescription',
    defaultMessage: 'Run a feature from another feature.'
  },
  runFeatureDescription: {
    id: 'SpaceAppBuilderFeaturesPage.operation.runFeatureDescription',
    defaultMessage: 'Define your run feature data using a variable from a previous step'
  },
  runCapabilityDescription: {
    id: 'SpaceAppBuilderFeaturesPage.operation.runCeatureDescription',
    defaultMessage: 'Define your run capability data using a variable from a previous step'
  },
  loading: {
    id: 'SpaceAppBuilderFeaturesPage.operations.loading',
    defaultMessage: 'Loading data source actions...'
  },
  action: {
    id: 'SpaceAppBuilderFeaturesPage.operations.dataStorage.action',
    defaultMessage: 'Action'
  },
  selectAnAction: {
    id: 'SpaceAppBuilderFeaturesPage.operations.dataStorage.selectAnAction',
    defaultMessage: 'Select An Action'
  },
  expiresAfter: {
    id: 'SpaceAppBuilderFeaturesPage.operations.dataStorage.expiresAfter',
    defaultMessage: 'Expires after'
  },
  append: {
    id: 'SpaceAppBuilderFeaturesPage.operations.dataStorage.append',
    defaultMessage: 'Append'
  },
  replace: {
    id: 'SpaceAppBuilderFeaturesPage.operations.dataStorage.replace',
    defaultMessage: 'Replace'
  },
  getAllRecords: {
    id: 'SpaceAppBuilderFeaturesPage.operations.dataStorage.getAllRecords',
    defaultMessage: 'Get All Records'
  },
  getRecordByKeyIdentifier: {
    id: 'SpaceAppBuilderFeaturesPage.operations.dataStorage.getRecordByKeyIdentifier',
    defaultMessage: 'Get Record By Key Identifier'
  },
  deletingByStorageName: {
    id: 'SpaceAppBuilderFeaturesPage.operations.dataStorage.deletingByStorageName',
    defaultMessage: 'Delete Records By Storage Name'
  },
  deletingByKeyIdentifier: {
    id: 'SpaceAppBuilderFeaturesPage.operations.dataStorage.deletingByKeyIdentifier',
    defaultMessage: 'Delete Record By Key Identifier'
  },
  appendDesc: {
    id: 'SpaceAppBuilderFeaturesPage.operations.dataStorage.appendDesc',
    defaultMessage:
      'This will append data to the key identifier list, if no existing data exists it will create a new list'
  },
  replaceDesc: {
    id: 'SpaceAppBuilderFeaturesPage.operations.dataStorage.replaceDesc',
    defaultMessage: 'This will overwrite data for storage name and key identifier'
  },
  getAllRecordsDesc: {
    id: 'SpaceAppBuilderFeaturesPage.operations.dataStorage.getAllRecordsDesc',
    defaultMessage: 'This will retrieve all data by name of storage'
  },
  getRecordByKeyDesc: {
    id: 'SpaceAppBuilderFeaturesPage.operations.dataStorage.getRecordByKeyDesc',
    defaultMessage: 'This will retrieve an individual record by the key identifier'
  },
  deleteAllRecordsDesc: {
    id: 'SpaceAppBuilderFeaturesPage.operations.dataStorage.deleteAllRecordsDesc',
    defaultMessage: 'This will delete all data by the storage name across features'
  },
  deleteRecordByKeyDesc: {
    id: 'SpaceAppBuilderFeaturesPage.operations.dataStorage.deleteRecordByKeyDesc',
    defaultMessage: 'This will delete an individual record by the key identifier'
  },
  dataDesc: {
    id: 'SpaceAppBuilderFeaturesPage.operations.dataStorage.dataDesc',
    defaultMessage: 'What is the data you are storing in relation to?'
  },
  dataDescPlaceholder: {
    id: 'SpaceAppBuilderFeaturesPage.operations.dataStorage.dataDescPlaceholder',
    defaultMessage: 'ex. Inbox item'
  },
  keyIdentifier: {
    id: 'SpaceAppBuilderFeaturesPage.operations.dataStorage.keyIdentifier',
    defaultMessage: 'Key Identifier'
  },
  keyIdentifierPlaceholder: {
    id: 'SpaceAppBuilderFeaturesPage.operations.dataStorage.keyIdentifierPlaceholder',
    defaultMessage: 'ex. Employee ID'
  },
  dataToStore: {
    id: 'SpaceAppBuilderFeaturesPage.operations.dataStorage.dataToStore',
    defaultMessage: 'Data to store'
  },
  dataToStorePlaceholder: {
    id: 'SpaceAppBuilderFeaturesPage.operations.dataStorage.dataToStorePlaceholder',
    defaultMessage: 'ex. Inbox record'
  },
  storageName: {
    id: 'SpaceAppBuilderFeaturesPage.operations.dataStorage.storageName',
    defaultMessage: 'Storage Name'
  },
  actions: {
    id: 'SpaceAppBuilderFeaturesPage.operations.actions',
    defaultMessage: 'Actions'
  },
  addVariableButton: {
    id: 'SpaceAppBuilderFeaturesPage.operations.insertVariableButton',
    defaultMessage: 'Insert variable'
  },
  addMessage: {
    id: 'SpaceAppBuilderFeaturesPage.operations.addMessage',
    defaultMessage: 'Add Message'
  },
  addUserQuery: {
    id: 'SpaceAppBuilderFeaturesPage.operations.addUserQuery',
    defaultMessage: 'Add Query'
  },
  dataSources: {
    id: 'SpaceAppBuilderFeaturesPage.operations.dataSources',
    defaultMessage: 'Data Sources'
  },
  rest: {
    id: 'SpaceAppBuilderFeaturesPage.operations.rest',
    defaultMessage: 'REST'
  },
  logicBuilder: {
    id: 'SpaceAppBuilderFeaturesPage.operations.logicBuilder',
    defaultMessage: 'Logic Builder'
  },
  noDataSources: {
    id: 'SpaceAppBuilderFeaturesPage.noDataSources',
    defaultMessage: 'No data sources connected'
  },
  noDataSourceActions: {
    id: 'SpaceAppBuilderFeaturesPage.noDataSourceActions',
    defaultMessage: 'No data source actions available'
  },
  noDataSourceActionsFound: {
    id: 'SpaceAppBuilderFeaturesPage.noDataSourceActions',
    defaultMessage: 'No data source actions found'
  },
  generalOperations: {
    id: 'SpaceAppBuilderFeaturesPage.generalOperations',
    defaultMessage: 'General'
  },
  notificationOperations: {
    id: 'SpaceAppBuilderFeaturesPage.notificationOperations',
    defaultMessage: 'Notifications'
  },
  dataTransformOperations: {
    id: 'SpaceAppBuilderFeaturesPage.dataTransformOperations',
    defaultMessage: 'Data Transform'
  },
  advancedOperations: {
    id: 'SpaceAppBuilderFeaturesPage.advancedOperations',
    defaultMessage: 'Advanced'
  },
  inputVariable: {
    id: 'SpaceAppBuilderFeaturesPage.inputVariable',
    defaultMessage: 'Input Variable'
  },
  loopVar: {
    id: 'SpaceAppBuilderFeaturesPage.loopVariable',
    defaultMessage: 'Loop Variable'
  },
  booleanVarErrorMessage: {
    id: 'SpaceAppBuilderFeaturesPage.booleanVariable.booleanVarErrorMessage',
    defaultMessage: 'Please add a step before the Boolean that has variables.'
  },
  loopVarErrorMessage: {
    id: 'SpaceAppBuilderFeaturesPage.loopVariable.loopVarErrorMessage',
    defaultMessage: 'Please add a step before the Loop that has an array, or list of items.'
  },
  apiRequestErrorMessage: {
    id: 'SpaceAppBuilderFeaturesPage.apiRequestErrorMessage',
    defaultMessage: 'Please add a data source to set up a Data Source API request'
  },
  survey: {
    id: 'SpaceAppBuilderFeaturesPage.operation.survey',
    defaultMessage: 'Survey'
  },
  surveyDescription: {
    id: 'SpaceAppBuilderFeaturesPage.operation.survey.description',
    defaultMessage: 'Send a survey.'
  },
  approval: {
    id: 'SpaceAppBuilderFeaturesPage.operation.approval',
    defaultMessage: 'Approval'
  },
  approvalDescription: {
    id: 'SpaceAppBuilderFeaturesPage.operation.approval.description',
    defaultMessage: 'Send an approval.'
  },
  callFunction: {
    id: 'SpaceAppBuilderFeaturesPage.operation.callFunction',
    defaultMessage: 'Call Function'
  },
  callFunctionDescription: {
    id: 'SpaceAppBuilderFeaturesPage.operation.callFunction.description',
    defaultMessage: 'Call a function.'
  },
  dataSourceAction: {
    id: 'SpaceAppBuilderFeaturesPage.operation.dataSourceAction',
    defaultMessage: 'Get Data Object'
  },
  dataSourceActionDescription: {
    id: 'SpaceAppBuilderFeaturesPage.operation.dataSourceAction.description',
    defaultMessage: 'Integrate with a data source'
  },
  condition: {
    id: 'SpaceAppBuilderFeaturesPage.operation.condition',
    defaultMessage: 'If...then'
  },
  loop: {
    id: 'SpaceAppBuilderFeaturesPage.operation.loop',
    defaultMessage: 'Loop'
  },
  setConfigVariable: {
    id: 'SpaceAppBuilderFeaturesPage.operation.setConfigVariable',
    defaultMessage: 'Update Config Variable'
  },
  setConfigVariableDescription: {
    id: 'SpaceAppBuilderFeaturesPage.operation.setConfigVariableDescription',
    defaultMessage:
      "Update a feature's config variable during a feature execution with a new value when this step is run."
  },
  loopDescription: {
    id: 'SpaceAppBuilderFeaturesPage.operation.loop.description',
    defaultMessage: 'Loop over list variable from previous steps.'
  },
  getVariable: {
    id: 'SpaceAppBuilderFeaturesPage.operation.getVariable',
    defaultMessage: 'Get Variable'
  },
  setVariable: {
    id: 'SpaceAppBuilderFeaturesPage.operation.setVariable',
    defaultMessage: 'Set Variable'
  },
  log: {
    id: 'SpaceAppBuilderFeaturesPage.operation.log',
    defaultMessage: 'Log'
  },
  uploadFile: {
    id: 'SpaceAppBuilderFeaturesPage.operation.uploadFile',
    defaultMessage: 'Upload File'
  },
  uploadFileDescription: {
    id: 'SpaceAppBuilderFeaturesPage.operation.uploadFileDescription',
    defaultMessage: 'This operation will upload a file.'
  },
  readFile: {
    id: 'SpaceAppBuilderFeaturesPage.operation.readFile',
    defaultMessage: 'Read File'
  },
  readFileDescription: {
    id: 'SpaceAppBuilderFeaturesPage.operation.readFileDescription',
    defaultMessage: 'This operation will read a file.'
  },
  logDescription: {
    id: 'SpaceAppBuilderFeaturesPage.operation.log.description',
    defaultMessage: 'This Component accepts a message to print to the log.'
  },
  delay: {
    id: 'SpaceAppBuilderFeaturesPage.operation.delay',
    defaultMessage: 'Delay'
  },
  unkownInput: {
    id: 'SpaceAppBuilderFeaturesPage.dataSourceAction.unkownInput',
    defaultMessage: 'Unknown input:'
  },
  whatAction: {
    id: 'SpaceAppBuilderFeaturesPage.dataSourceAction.whatAction',
    defaultMessage: 'What Action?'
  },
  fields: {
    id: 'SpaceAppBuilderFeaturesPage.dataSourceAction.fields',
    defaultMessage: 'Fields'
  },
  filterBy: {
    id: 'SpaceAppBuilderFeaturesPage.dataSourceAction.filterBy',
    defaultMessage: 'Filter By'
  },
  addFilter: {
    id: 'SpaceAppBuilderFeaturesPage.dataSourceAction.addFilter',
    defaultMessage: 'Add Filter'
  },
  selectField: {
    id: 'SpaceAppBuilderFeaturesPage.dataSourceAction.selectField',
    defaultMessage: 'Select Field'
  },
  selectValue: {
    id: 'SpaceAppBuilderFeaturesPage.dataSourceAction.selectValue',
    defaultMessage: 'Select Value'
  },
  selectOperator: {
    id: 'SpaceAppBuilderFeaturesPage.dataSourceAction.selectOperator',
    defaultMessage: 'Select Operator'
  },
  enterValue: {
    id: 'SpaceAppBuilderFeaturesPage.dataSourceAction.enterValue',
    defaultMessage: 'Enter Value'
  },
  removeFilter: {
    id: 'SpaceAppBuilderFeaturesPage.dataSourceAction.removeFilter',
    defaultMessage: 'Remove Filter'
  },
  content: {
    id: 'SpaceAppBuilderFeaturesPage.dataSourceAction.content',
    defaultMessage: 'Content'
  },
  advanced: {
    id: 'SpaceAppBuilderFeaturesPage.dataSourceAction.advanced',
    defaultMessage: 'ADVANCED'
  },
  fieldsDescription: {
    id: 'SpaceAppBuilderFeaturesPage.dataSourceAction.fieldsDescription',
    defaultMessage: 'The fields to return on the response.'
  },
  noInput: {
    id: 'SpaceAppBuilderFeaturesPage.dataSourceAction.noInput',
    defaultMessage: 'no input'
  },
  saveOutputVariable: {
    id: 'SpaceAppBuilderFeaturesPage.dataSourceAction.saveOutputVariable',
    defaultMessage: 'Save output variable as:'
  },
  input: {
    id: 'SpaceAppBuilderFeaturesPage.dataSourceAction.input',
    defaultMessage: 'Input'
  },
  dataSource: {
    id: 'SpaceAppBuilderFeaturesPage.dataSourceAction.dataSource',
    defaultMessage: 'Data Source:'
  },
  noDataSourceConnected: {
    id: 'SpaceAppBuilderFeaturesPage.dataSourceAction.noDataSources',
    defaultMessage: 'No Data Sources Connected'
  },
  selectDataSource: {
    id: 'SpaceAppBuilderFeaturesPage.dataSourceAction.selectDataSource',
    defaultMessage: 'Please select a Data Source'
  },
  selectOperation: {
    id: 'SpaceAppBuilderFeaturesPage.dataSourceAction.selectOperation',
    defaultMessage: 'Select an operation'
  },
  requiredStar: {
    id: 'SpaceAppBuilderFeaturesPage.validation.requiredStar',
    defaultMessage: '*'
  },
  logMessageRequired: {
    id: 'SpaceAppBuilderFeaturesPage.validation.logMessageRequired',
    defaultMessage: 'Message is a required field'
  },
  userQueryRequired: {
    id: 'SpaceAppBuilderFeaturesPage.validation.userQueryRequired',
    defaultMessage: 'User Query is a required field'
  },
  loopInputVariableRequired: {
    id: 'SpaceAppBuilderFeaturesPage.validation.loopInputVariableRequired',
    defaultMessage: 'Loop Input Variable is a required field'
  },
  dataTransformVarErrorMessage: {
    id: 'SpaceAppBuilderFeaturesPage.dataTransform.dataTransformVarErrorMessage',
    defaultMessage: 'Please add a step before the data transform utility that outputs variables.'
  },
  dataTransformInputVariableRequired: {
    id: 'SpaceAppBuilderFeaturesPage.validation.dataTransformInputVariableRequired',
    defaultMessage: 'Input Variable is a required field'
  },
  dataTransformInputActionNameRequired: {
    id: 'SpaceAppBuilderFeaturesPage.validation.dataTransformInputActionNameRequired',
    defaultMessage: 'Action is a required field'
  },
  dataTransformInputActionsMinLength1: {
    id: 'SpaceAppBuilderFeaturesPage.validation.dataTransformInputActionsMinLength1',
    defaultMessage: 'At least one action must be configured for a transform.'
  },
  dataTransformNoAvailableActionsForType: {
    id: 'SpaceAppBuilderFeaturesPage.validation.dataTransformNoAvailableActionsForType',
    defaultMessage: 'There are currently no available actions for the {type} data type.'
  },
  dataTransformSeeExample: {
    id: 'SpaceAppBuilderFeaturesPage.validation.dataTransformSeeExample',
    defaultMessage: 'See {name} Example'
  },
  dataTransformNoAvailableActions: {
    id: 'SpaceAppBuilderFeaturesPage.validation.dataTransformNoAvailableActions',
    defaultMessage: 'There are currently no more actions.'
  },
  dataTransformNotSeeingAction: {
    id: 'SpaceAppBuilderFeaturesPage.validation.dataTransformNotSeeingAction',
    defaultMessage: 'Not seeing an action you were looking for?'
  },
  dataTransformLetUsKnow: {
    id: 'SpaceAppBuilderFeaturesPage.validation.dataTransformLetUsKnow',
    defaultMessage: 'Let us know'
  },

  getDOEndpointRequired: {
    id: 'SpaceAppBuilderFeaturesPage.validation.getDOEndpointRequired',
    defaultMessage: 'Operation is a required field'
  },
  getDOOutputVarRequired: {
    id: 'SpaceAppBuilderFeaturesPage.validation.getDOOutputVarRequired',
    defaultMessage: 'Output Variable is a required field'
  },
  dataSourceIdFieldRequired: {
    id: 'SpaceAppBuilderFeaturesPage.validation.dataSourceIdFieldRequired',
    defaultMessage: 'Data Source Id field is a required field'
  },
  queryStringRequired: {
    id: 'SpaceAppBuilderFeaturesPage.validation.queryStringRequired',
    defaultMessage: 'Query string is a required field'
  },
  endpointPathRequired: {
    id: 'SpaceAppBuilderFeaturesPage.validation.endpointPathRequired',
    defaultMessage: 'Endpoint is a required field'
  },
  sourceRequired: {
    id: 'SpaceAppBuilderFeaturesPage.validation.sourceRequired',
    defaultMessage: 'Source is a required field'
  },
  queryNameRequired: {
    id: 'SpaceAppBuilderFeaturesPage.validation.queryNameRequired',
    defaultMessage: 'Query name is a required field'
  },
  queryValueRequired: {
    id: 'SpaceAppBuilderFeaturesPage.validation.queryValueRequired',
    defaultMessage: 'Query value is a required field'
  },
  stepName: {
    id: 'SpaceAppBuilderFeaturesPage.operations.stepName',
    defaultMessage: 'Step Name'
  },
  close: {
    id: 'SpaceAppBuilderFeaturesPage.operations.close',
    defaultMessage: 'Close'
  },
  manualTriggerDescription: {
    id: 'SpaceAppBuilderFeaturesPage.manualTriggerDescription',
    defaultMessage: 'This feature will run when you click the "play" button when viewing the feature.'
  },
  scheduledTriggerDescription: {
    id: 'SpaceAppBuilderFeaturesPage.scheduledTriggerDescription',
    defaultMessage: 'Run feature at scheduled time or interval.'
  },
  saveAction: {
    id: 'SpaceAppBuilderFeaturesPage.button.save',
    defaultMessage: 'Save'
  },
  cancelAction: {
    id: 'SpaceAppBuilderFeaturesPage.button.cancel',
    defaultMessage: 'Cancel'
  },
  fieldRequired: {
    id: 'SpaceAppBuilderFeaturesPage.operation.filters.required',
    defaultMessage: 'Filters are required'
  },
  apiRequest: {
    id: 'SpaceAppBuilderFeaturesPage.apiRequest',
    defaultMessage: 'API Request'
  },
  apiRequestDescription: {
    id: 'SpaceAppBuilderFeaturesPage.apiRequest.apiRequestDescription',
    defaultMessage: 'Connect to a custom API URL'
  },
  method: {
    id: 'SpaceAppBuilderFeaturesPage.apiRequest.method',
    defaultMessage: 'Method'
  },
  baseUrl: {
    id: 'SpaceAppBuilderFeaturesPage.apiRequest.baseUrl',
    defaultMessage: 'Base Url'
  },
  get: {
    id: 'SpaceAppBuilderFeaturesPage.apiRequest.get',
    defaultMessage: 'Get'
  },
  source: {
    id: 'SpaceAppBuilderFeaturesPage.apiRequest.source',
    defaultMessage: 'Source'
  },
  endpoint: {
    id: 'SpaceAppBuilderFeaturesPage.apiRequest.endpoint',
    defaultMessage: 'Endpoint'
  },
  beautify: {
    id: 'SpaceAppBuilderFeaturesPage.codeEditor.beautify',
    defaultMessage: 'Beautify Code'
  },
  enterEndpoint: {
    id: 'SpaceAppBuilderFeaturesPage.apiRequest.enterEndpoint',
    defaultMessage: 'Enter endpoint'
  },
  slash: {
    id: 'SpaceAppBuilderFeaturesPage.apiRequest.slash',
    defaultMessage: '/'
  },
  queryParameter: {
    id: 'SpaceAppBuilderFeaturesPage.apiRequest.queryParameter',
    defaultMessage: 'Query Parameter'
  },
  queryTitle: {
    id: 'SpaceAppBuilderFeaturesPage.apiRequest.queryTitle',
    defaultMessage: 'Query {index}'
  },
  enterQueryName: {
    id: 'SpaceAppBuilderFeaturesPage.apiRequest.enterQueryName',
    defaultMessage: 'Enter query name'
  },
  selectQuery: {
    id: 'SpaceAppBuilderFeaturesPage.apiRequest.selectQuery',
    defaultMessage: 'Select query'
  },
  dataSourceSelect: {
    id: 'SpaceAppBuilderFeaturesPage.apiRequest.dataSourceSelect',
    defaultMessage: 'Select data source'
  },
  addQuery: {
    id: 'SpaceAppBuilderFeaturesPage.apiRequest.addQuery',
    defaultMessage: 'Add query parameter'
  },
  requestPreview: {
    id: 'SpaceAppBuilderFeaturesPage.apiRequest.requestPreview',
    defaultMessage: 'Request Preview'
  },
  moreInformation: {
    id: 'SpaceAppBuilderFeaturesPage.apiRequest.moreInformation',
    defaultMessage: 'For more information see API Docs'
  },
  dataStorage: {
    id: 'SpaceAppBuilderFeaturesPage.operation.dataStorage.label',
    defaultMessage: 'Data Storage'
  },
  operation: {
    id: 'SpaceAppBuilderFeaturesPage.operation.dataStorage.operation',
    defaultMessage: 'Operation'
  },
  modifyData: {
    id: 'SpaceAppBuilderFeaturesPage.operation.dataStorage.modifyData',
    defaultMessage: 'Modify Data'
  },
  readData: {
    id: 'SpaceAppBuilderFeaturesPage.operation.dataStorage.readData',
    defaultMessage: 'Read Data'
  },
  operationRequired: {
    id: 'SpaceAppBuilderFeaturesPage.validation.operationRequired',
    defaultMessage: 'Data Storage Operation Required'
  },
  actionTypeRequired: {
    id: 'SpaceAppBuilderFeaturesPage.validation.actionTypeRequired',
    defaultMessage: 'Action Type Required'
  },
  dataRequired: {
    id: 'SpaceAppBuilderFeaturesPage.validation.dataRequired',
    defaultMessage: 'Storage Name Required'
  },
  keyIdentifierRequired: {
    id: 'SpaceAppBuilderFeaturesPage.validation.keyIdentifierRequired',
    defaultMessage: 'Key Identifier Required'
  },
  dataToStoreRequired: {
    id: 'SpaceAppBuilderFeaturesPage.validation.dataToStoreRequired',
    defaultMessage: 'Data to store required'
  },
  operationNameRequired: {
    id: 'SpaceAppBuilderFeaturesPage.validation.operationNameRequired',
    defaultMessage: 'Operation Name is a required field'
  },
  response: {
    id: 'SpaceAppBuilderFeaturesPage.operation.response',
    defaultMessage: 'Response'
  },
  responseDescription: {
    id: 'SpaceAppBuilderFeaturesPage.operation.responseDescription',
    defaultMessage: "Define your feature's response."
  },
  responseSubDescription: {
    id: 'SpaceAppBuilderFeaturesPage.operation.responseSubDescription',
    defaultMessage:
      'A feature can return multiple items in its response, but typically returns just one. Response items should be either a string of text or an adaptive card, and will be consumed by the Workgrid clients in the order that they are defined.'
  },
  responseData: {
    id: 'SpaceAppBuilderFeaturesPage.operation.responseData',
    defaultMessage: 'Response'
  },
  variableInput: {
    id: 'SpaceAppBuilderFeaturesPage.operation.variableInput',
    defaultMessage: 'Variable Input'
  },
  responseVarErrorMessage: {
    id: 'SpaceAppBuilderFeaturesPage.responseVariable.responseVarErrorMessage',
    defaultMessage: 'Please add a step before the response that outputs variables'
  },
  responseInputVariableRequired: {
    id: 'SpaceAppBuilderFeaturesPage.validation.responseInputVariableRequired',
    defaultMessage: 'Response Input Variable is a required field'
  },
  apiDocs: {
    id: 'SpaceAppBuilderFeaturesPage.validation.apiDocs',
    defaultMessage: 'API Docs'
  },
  supportLink: {
    id: 'SpaceAppBuilderFeaturesPage.validation.supportLink',
    defaultMessage: 'Help'
  },
  pleaseResolveErrors: {
    id: 'SpaceAppBuilderFeaturesPage.validation.pleaseResolveErrors',
    defaultMessage: 'Please resolve the following errors!'
  },
  pleaseCompleteFields: {
    id: 'SpaceAppBuilderFeaturesPage.validation.pleaseCompleteFields',
    defaultMessage: 'To complete and run this feature, please update the following fields:'
  },
  appUiView: {
    id: 'SpaceAppBuilderFeaturesPage.operation.appUiView',
    defaultMessage: 'App UI View'
  },
  agentUiView: {
    id: 'SpaceAppBuilderFeaturesPage.operation.appUiView',
    defaultMessage: 'Agent UI View'
  },
  featureIdOfView: {
    id: 'SpaceAppBuilderFeaturesPage.operation.featureIdOfView',
    defaultMessage: 'Feature Id of View'
  },
  sendAppUINotification: {
    id: 'SpaceAppBuilderFeaturesPage.operation.sendAppUINotification',
    defaultMessage: 'App UI Notification'
  },
  sendAgentUINotification: {
    id: 'SpaceAppBuilderFeaturesPage.operation.sendAppUINotification',
    defaultMessage: 'Agent UI Notification'
  },
  sendAppUINotificationDescription: {
    id: 'SpaceAppBuilderFeaturesPage.operation.sendAppUINotificationDescription',
    defaultMessage: 'Send a notification to a specified audience based on rules.'
  },
  appUiViewRequired: {
    id: 'SpaceAppBuilderFeaturesPage.operation.appUiViewRequired',
    defaultMessage: 'App UI View is a required field'
  },
  agentUiViewRequired: {
    id: 'SpaceAppBuilderFeaturesPage.operation.appUiViewRequired',
    defaultMessage: 'Agent UI View is a required field'
  },
  documentTextSplitter: {
    id: 'SpaceAppBuilderFeaturesPage.operation.documentTextSplitter',
    defaultMessage: 'Document Text Splitter'
  },
  documentTextSplitterDescription: {
    id: 'SpaceAppBuilderFeaturesPage.operation.documentTextSplitterDescription',
    defaultMessage: 'Splits document text into chunks.'
  },
  documentTextSplitterDocText: {
    id: 'SpaceAppBuilderFeaturesPage.operation.documentTextSplitterDocText',
    defaultMessage: 'Document Text'
  },
  documentTextSplitterEnterDocText: {
    id: 'SpaceAppBuilderFeaturesPage.validation.documentTextSplitterEnterDocText',
    defaultMessage: 'Enter document text'
  },
  documentTextSplitterNumberRequired: {
    id: 'SpaceAppBuilderFeaturesPage.validation.documentTextSplitterNumberRequired',
    defaultMessage: 'Numeric value is required'
  },
  documentTextSplitterDocTextRequired: {
    id: 'SpaceAppBuilderFeaturesPage.validation.documentTextSplitterDocTextRequired',
    defaultMessage: 'Document Text is a required field'
  },
  documentTextSplitterChunkSize: {
    id: 'SpaceAppBuilderFeaturesPage.operation.documentTextSplitterChunkSize',
    defaultMessage: 'Chunk Size'
  },
  documentTextSplitterChunkSizeRange: {
    id: 'SpaceAppBuilderFeaturesPage.operation.documentTextSplitterChunkSizeRange',
    defaultMessage: 'Chunk Size must be between 500 and 4000.'
  },
  documentTextSplitterChunkSizeSubtitle: {
    id: 'SpaceAppBuilderFeaturesPage.operation.documentTextSplitterChunkSizeSubtitle',
    defaultMessage: 'The maximum number of characters that a chunk can contain.'
  },
  documentUrl: {
    id: 'SpaceAppBuilderFeaturesPage.operation.documentUrl',
    defaultMessage: 'Document URL'
  },
  enterDocumentUrl: {
    id: 'SpaceAppBuilderFeaturesPage.operation.enterDocumentUrl',
    defaultMessage: 'Enter document URL'
  },
  queryableFeature: {
    id: 'SpaceAppBuilderFeaturesPage.operation.queryableFeatureId',
    defaultMessage: 'Queryable Feature'
  },
  selectQueryableFeature: {
    id: 'SpaceAppBuilderFeaturesPage.operation.selectQueryableFeature',
    defaultMessage: 'Select Feature'
  },
  writeToDocumentStore: {
    id: 'SpaceAppBuilderFeaturesPage.operation.writeToDocumentStore',
    defaultMessage: 'Write to Document Store?'
  },
  arrayVariableErrorMessage: {
    id: 'SpaceAppBuilderFeaturesPage.operation.arrayVariableErrorMessage',
    defaultMessage: 'Please add a step before the operation that has an array, or list of items.'
  },
  documentChunks: {
    id: 'SpaceAppBuilderFeaturesPage.operation.documentChunks',
    defaultMessage: 'Document Chunks'
  },
  documentChunksSubtitle: {
    id: 'SpaceAppBuilderFeaturesPage.operation.documentChunksSubtitle',
    defaultMessage:
      'This is the original document converted into chunks and then embeddings so that the document embeddings can be compared against the question embeddings.'
  },
  enterDocumentChunks: {
    id: 'SpaceAppBuilderFeaturesPage.operation.enterDocumentChunks',
    defaultMessage: 'Enter document chunks embeddings'
  },
  searchStorage: {
    id: 'SpaceAppBuilderFeaturesPage.operation.searchStorage',
    defaultMessage: 'Document Search Storage'
  },
  ConfigurationStepDefaultPriority: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.Priority.Default',
    defaultMessage: 'Priority'
  },
  ConfigurationStepDefaultPriorityInformational: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.Priority.Informational',
    defaultMessage: 'Informational'
  },
  ConfigurationStepDefaultPriorityImportant: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.Priority.Important',
    defaultMessage: 'Important'
  },
  ConfigurationStepDefaultPriorityCritical: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.Priority.Critical',
    defaultMessage: 'Critical'
  },
  DataCollectionSet: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.detail.dataCollectionSet',
    defaultMessage: 'Data Collection Set'
  },
  PriorityError: {
    id: 'SpaceAppBuilderFeaturesPage.operation.notification.PriorityError',
    defaultMessage: 'Please select a priority.'
  },
  deployFeature: {
    id: 'SpaceAppBuilderFeaturesPage.operations.deployFeature',
    defaultMessage: 'Deploy Feature'
  },
  deployCapability: {
    id: 'SpaceAppBuilderFeaturesPage.operations.deployFeature',
    defaultMessage: 'Deploy Capability'
  },
  invokeLambda: {
    id: 'SpaceAppBuilderFeaturesPage.operations.invokeLambda',
    defaultMessage: 'Invoke Lambda'
  },
  invokeLambdaStepDescription: {
    id: 'SpaceAppBuilderFeaturesPage.operation.invokeLambdaStepDescription',
    defaultMessage: 'Invoke a lambda by executing this step'
  },
  generateMicroappToken: {
    id: 'SpaceAppBuilderFeaturesPage.operations.generateMicroappToken',
    defaultMessage: 'Generate Microapp Token'
  },
  generateMicroappStepDescription: {
    id: 'SpaceAppBuilderFeaturesPage.operation.generateMicroappStepDescription',
    defaultMessage: 'Generate a Microapp Token by executing this step'
  },
  deployFeatureStepDescription: {
    id: 'SpaceAppBuilderFeaturesPage.operation.deployFeatureStepDescription',
    defaultMessage: 'Deploy the current app or feature by executing this step'
  },
  deployCapabilityStepDescription: {
    id: 'SpaceAppBuilderFeaturesPage.operation.deployCapabilityStepDescription',
    defaultMessage: 'Deploy the current app or capability by executing this step'
  },
  deployType: {
    id: 'SpaceAppBuilderFeaturesPage.operations.deployType',
    defaultMessage: 'Deploy Type'
  },
  deployFeatureSelectType: {
    id: 'SpaceAppBuilderFeaturesPage.operations.deployFeatureSelectType',
    defaultMessage: 'Select deployment type'
  },
  deployApp: {
    id: 'SpaceAppBuilderFeaturesPage.operations.deployApp',
    defaultMessage: 'Deploy App'
  },
  deployFeatureModeRequired: {
    id: 'SpaceAppBuilderFeaturesPage.validation.deployFeatureModeRequired',
    defaultMessage: 'Mode is a required field'
  }
})
